export const getVisiblePages = (page: number, total: number): number[] => {
  if (total < 7) {
    return Array.from({ length: total }, (_, i) => i + 1).slice(1, total - 1)
  }
  if (page % 5 >= 0 && page > 4 && page + 2 < total) {
    return [page - 1, page, page + 1, page + 2]
  }
  if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
    return [total - 3, total - 2, total - 1]
  }
  return [2, 3, 4, 5]
}
